import { Col, Row, Form, Checkbox } from 'antd'
import withSort from '../elements/HOC/withSort'
import { defaultFormItemLayout } from '../modules/FormItems'
import { strVal } from '../modules/Utils'
import React from 'react'
import { compose } from 'recompose'
import withSpinning from '../elements/HOC/withSpinning'
import CustomSelect from '../elements/Select/CustomSelect'
import withSelectFetch from '../elements/Select/withSelectFetch'

function PartnerGroup({ getFieldDecorator, data, setFieldsValue, getFieldValue }) {
  return (
    <Row>
      <Col span={12}>
        <Form.Item {...defaultFormItemLayout} label="PartnerGroup">
          {getFieldDecorator('partnerGroup.group', {
            initialValue: strVal(data, 'partnerGroup.group'),
          })(
            <PartnerGroupType
              style={{ width: '100%' }}
              placeholder="Partner Group"
              onChange={(i) => {
                setFieldsValue({ 'partnerGroup.remittance': !!i })
              }}
            />
          )}
        </Form.Item>
      </Col>

      <Col span={12}>
        <Form.Item {...defaultFormItemLayout} label="Group Remittance">
          {getFieldDecorator('partnerGroup.remittance', {
            initialValue: strVal(data, 'groupRemittance'),
            valuePropName: 'checked',
          })(<Checkbox disabled={!getFieldValue('partnerGroup')} />)}
        </Form.Item>
      </Col>
    </Row>
  )
}

export default PartnerGroup

const PartnerGroupType = compose(
  withSelectFetch({
    dropdown: 'partnerGroup',
    name: 'group',
  }),
  withSpinning,
  withSort
)(CustomSelect)
